import { Component } from '@angular/core';
import { fadeAnimation } from '../../animations/route-animations';

/** "Mentioned in:" separator over the press logos, as on the intro screen. */
@Component({
  selector: 'app-mentioned-in',
  templateUrl: './mentioned-in.component.html',
  styleUrls: ['./mentioned-in.component.scss'],
  animations: [fadeAnimation],
})
export class MentionedInComponent {}
